/**
 * Main
 *
 * ModuleDescription
 *
 * @return {type}
 */

OT.createNS('OT.Redesign.init');

OT.Redesign.init = function () {
  'use strict';
  var pid;
  var rowToView;

  window.OTCurrentPage = 'search';

  OT.Common.LoadBannerEmblem.init();

  // Set our config values
  OT.Search.Config.set({
    logEventPrefix: 'Redesign',
    resultRetriesMax: 3,
    showDistanceInResults: OT.Common.TestObject.isActive('ShowDistanceInResults')
  });

  // Replace the current history state
  OT.Search.History.setInitialState();

  // Listen for history events
  if (OT.Search.History.isSupported) {
    window.onpopstate = function (e) {
      if (e.state === null || OT.Search.Params.isEqual(e.state)) {
        return false;
      }

      OT.Search.Params.clear().set(e.state);
      OT.Search.Requests.Results.get({
        additionalData: {
          supressHistory: true,
          historyBack: true
        }
      });
    };
  }

  OT.Events.on('results:cancel', function () {
    OT.Common.Helpers.redirectWindow(OT.Search.Requests.BuildUrl.queryString());
  });

  // Set the default API route
  OT.Search.Requests.BuildUrl.setApiRoute(window.location.pathname, "/node/api");

  if (OT.Search.Helpers.QueryString().pid !== undefined) {
    pid = OT.Search.Helpers.QueryString().pid;
    rowToView = $("div").find("[data-rid='" + pid + "']");

    if (rowToView.length) {
      $(window).scrollTo(rowToView, 0, { offset: -50 });
    }
  }

  OT.Redesign.DropDown.init();

  // Initialise Search and Common views
  OT.createNS('OT.Common.views');
  OT.createNS('OT.Redesign.views');
  OT.createNS('OT.Search.helpers');
  OT.createNS('OT.Search.views');

  // Modals
  OT.Search.views.refineFiltersModal = new OT.Redesign.Views.Modals.RefineFiltersModal();
  OT.Search.views.singleSearchModal = new OT.Redesign.Views.Modals.SingleSearchModal();
  OT.Search.views.tooltipModal = new OT.Redesign.Views.Modals.Tooltip();

  // Header
  OT.Search.views.refineFiltersLink = new OT.Redesign.Views.RefineFiltersLink();

  // Results
  OT.Search.views.pagination = new OT.Redesign.Views.Results.Pagination();
  OT.Search.views.popTable = new OT.Redesign.Views.Results.PopTable();
  OT.Search.views.results = new OT.Redesign.Views.Results.Results();
  OT.Search.views.resultsContainer = new OT.Redesign.Views.Results.ResultsContainer();
  OT.Search.views.searchAnimation = new OT.Redesign.Views.SearchAnimation();

  // README: using delegation so that hook remains after client side re-renders
  $('#no-re-render-container').on('click', '.timeslot, .rest-row-image, .rest-row-name-text', function(e) {
    try {
      var rid = $(e.target).closest('.result').data('rid');
      var cid = OTSearchData.Results.CampaignIds[rid];
      var isPromoted = OTSearchData.Results.PromotedRids[rid];

      if (cid && isPromoted) {
        var values = {
          rid: rid,
          cid: cid,
          dateTime: new Date().toISOString()
        };
        window.localStorage.setItem('OTPromotionClick', JSON.stringify(values));
      }
    } catch (e) {
      console.log('failed to store promotion click: ', e);
    }
  });

  var data = window.OTSearchData;

  moment.locale(data.DomainCulture.language);

  data.localization = {
    selectedFiltersTitle: Resources.Shared.Redesign.Filters.Title_Filters.toUpperCase(),
    timeFormat: Resources.Strings.TimeFormat
  };

  var ga = {
    track: function(dataPoint) {
      window.MapTrackGA(dataPoint);
    }
  };

  OTSearchBundle.init({
    data: data,
    services: {
      oc: oc,
      ga: ga,
      search: function search(data) {
        OT.Search.Params.set(data);
        OT.Search.Requests.Results.get();
      },
      toggleFilterHighlights: function toggleFilterHighlight(filterDiffs) {
        OT.Events.fire('filters:update', [filterDiffs]);
        filterDiffs.forEach(function(diff) {
          var el = document.getElementById(diff.id);

          if (el) {
            diff.classNames.forEach(function(className) {
              el
                .parentElement
                .classList
                .toggle(className);
            });
          }
        });
      }
    }
  });

  // This logic is only applicable to tabbed price filters.
  // TODO: Remove (or move into a backbone class) after making tabbed price filters accessible
  $('.filter-option .all-filter').on('click', function(e) {
    var el = e.target;
    OTSearchBundle.setAllFilters(el.name);
  });

  $('.filter-option .filter').on('click', function(e) {
    var el = e.target;
    var data = el.dataset;
    OTSearchBundle.toggleFilter(el.name, data.id);
  });
  // End tabbed pricefilter only logic

  $('body').on('change', '#sort-filters .sort-option', function(e) {
    var el = e.target;
    OTSearchBundle.changeSort(el.value);
  });

  OT.Redesign.Views.TableCategories();

  // Main Page Views
  OT.Search.views.searchControl = new OT.Redesign.Views.SearchControl();

  // Helpers
  OT.Search.helpers.isMapShowing = new OT.Search.Helpers.isMapShowing();

  // Map
  OT.Search.views.results.mapResults = new OT.Redesign.Views.Results.MapResults();
  OT.Search.views.results.visualMapIcon = new OT.Redesign.Views.VisualMapIcon();

  // Filters
  var filterIdx = 0;
  OT.Search.views.filters = {};
  OT.Search.views.filters.checkboxFilterGroup = [];
  $('.filters__checkbox-group').each(function() {
    OT.Search.views.filters.checkboxFilterGroup[filterIdx++] = new OT.Redesign.Views.Filters.CheckboxFilterGroup({ el: $(this) });
  });
};
